import { Icon } from '@iconify/react';
import googleFill from '@iconify/icons-eva/google-fill';
// import appleFilled from '@iconify/icons-ant-design/apple-filled'; // TODO: re-enable when Apple login is ready
// material
import { Stack, Button, Divider, Typography } from '@material-ui/core';
// hooks
import useAuth from '../../hooks/useAuth';
import useLocales from '../../hooks/useLocales';

// ----------------------------------------------------------------------

export default function AuthFirebaseSocials() {
  const { loginWithGoogle } = useAuth();
  const { translate } = useLocales();

  const handleLoginGoogle = async () => {
    try {
      await loginWithGoogle();
    } catch (error) {
      console.error(error);
    }
  };

  // TODO: re-enable when Apple login is ready
  // const handleLoginApple = async () => {
  //   try {
  //     await loginWithApple();
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  return (
    <>
      <Stack direction="row" spacing={2}>
        <Button fullWidth size="large" color="inherit" variant="outlined" onClick={handleLoginGoogle}>
          <Icon icon={googleFill} color="#DF3E30" height={24} />
        </Button>

        {/* TODO: re-enable when Apple login is ready */}
        {/* <Button fullWidth size="large" color="inherit" variant="outlined" onClick={handleLoginApple}>
          <Icon icon={appleFilled} color="#000000" height={24} />
        </Button> */}
      </Stack>

      <Divider sx={{ my: 3 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {translate('auth.or')}
        </Typography>
      </Divider>
    </>
  );
}
